export default __webpack_public_path__ + "static/i2-81019a6bc9ffdbc1b7becaa5663c02ad.png";